export const servicesList = [
  {
    icon: "fas fa-robot",
    title: "AI Solutions",
    description:
      "AI agent development, Claude onboarding and managed operations, and practical AI training for Malaysian teams.",
    detailId: "as",
    features: [
      "Custom AI agent development",
      "Claude onboarding and setup",
      "Managed Claude operations",
      "Claude and AI training",
      "Workflow integration and support",
    ],
  },
  {
    icon: "fas fa-code",
    title: "Software Development and Support",
    description:
      "Custom software solutions tailored to your specific business needs and requirements.",
    detailId: "sds",
    features: [
      "Custom application development",
      "Legacy system modernization",
      "Mobile app development",
      "Enterprise software solutions",
      "Quality assurance and testing",
    ],
  },
  {
    icon: "fas fa-cloud",
    title: "Cloud Architecture Design and Implementation",
    description:
      "Robust cloud infrastructure to maximize scalability, security, and cost-efficiency.",
    detailId: "cadi",
    features: [
      "Cloud migration services",
      "Multi-cloud strategies",
      "Cloud-native application design",
      "Security and compliance",
      "Performance optimization",
    ],
  },
  {
    icon: "fas fa-laptop-code",
    title: "System Integration and Support",
    description:
      "Seamless integration of diverse systems to enable efficient data flow and processes.",
    detailId: "sis",
    features: [
      "API development and management",
      "Data integration services",
      "CRM and ERP integration",
      "Cloud service integration",
      "Middleware solutions",
    ],
  },
  {
    icon: "fas fa-shield-alt",
    title: "Enterprise Resilience Assessment",
    description:
      "Hands-on resilience engineering — chaos, load-to-failure, DR and SLOs — mapped to BNM RMiT & MAS. Plus independent audits of the testing you've already had done.",
    detailId: "er",
    features: [
      "Resilience & chaos assessment",
      "Load-to-failure & capacity testing",
      "DR & recovery (MTTR) validation",
      "Independent load-test audit",
      "BNM RMiT & MAS mapping",
    ],
  },
  {
    icon: "fas fa-globe",
    title: "Website Development & Hosting",
    description:
      "Professional website development with reliable hosting solutions for businesses of all sizes.",
    detailId: "wdh",
    features: [
      "Custom website development",
      "Responsive design",
      "CMS integration",
      "Cloud hosting solutions",
      "SSL certification & security",
    ],
  },
  {
    icon: "fas fa-graduation-cap",
    title: "Training & Education",
    description:
      "HRD Corp certified training for AI, digital transformation, and modern finance teams.",
    detailId: "te",
    features: [
      "HRD Corp approved programmes",
      "AI, digital, and finance upskilling",
      "Practitioner-led workshops",
      "Custom curriculum design",
      "Post-training enablement",
    ],
  },
  {
    icon: "fas fa-server",
    title: "Hardware & Software Provisioning",
    description:
      "We source and deploy state-of-the-art hardware and software solutions for competitive environments.",
    detailId: "hsp",
    features: [
      "Hardware procurement",
      "Software licensing",
      "Infrastructure setup",
      "Technology stack optimization",
      "Vendor management",
    ],
  },
];
